import Service from './Service';

const resource = '/atc-aka/v1/option';

export default {
    get(field) {
        return Service.get(`${resource}/${field}`);
    }
}